export default __webpack_public_path__ + "static/media/user-filled.649fd948.svg";